import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetSkuUpcMappingsQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
  where?: Types.InputMaybe<Types.SkuUpcMappingFilterInput>;
  order?: Types.InputMaybe<Array<Types.SkuUpcMappingSortInput> | Types.SkuUpcMappingSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSkuUpcMappingsQuery = { __typename?: 'Query', skuUpcMappings?: { __typename?: 'SkuUpcMappingsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SkuUpcMapping', id: string, tenantId: string, customerItemId: string, itemId: string, customerId: string, customerName: string, locationId?: string | null, locationName: string, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveShippingUomSource: Types.ShippingUomSource, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailShelfPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetSkuUpcMappingsForItemsQueryVariables = Types.Exact<{
  itemIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  where?: Types.InputMaybe<Types.SkuUpcMappingFilterInput>;
  order?: Types.InputMaybe<Array<Types.SkuUpcMappingSortInput> | Types.SkuUpcMappingSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSkuUpcMappingsForItemsQuery = { __typename?: 'Query', skuUpcMappingsForItems?: { __typename?: 'SkuUpcMappingsForItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SkuUpcMapping', id: string, tenantId: string, customerItemId: string, itemId: string, customerId: string, customerName: string, locationId?: string | null, locationName: string, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveShippingUomSource: Types.ShippingUomSource, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailShelfPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ResolveSkuUpcMappingQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
  customerLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  itemId: Types.Scalars['String']['input'];
  atMoment?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type ResolveSkuUpcMappingQuery = { __typename?: 'Query', resolveSkuUpcMapping?: { __typename?: 'SkuUpcMapping', id: string, tenantId: string, customerItemId: string, itemId: string, customerId: string, customerName: string, locationId?: string | null, locationName: string, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveShippingUomSource: Types.ShippingUomSource, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailShelfPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null };

export type GetResolvedSkuUpcMappingsQueryVariables = Types.Exact<{
  itemIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  customerId: Types.Scalars['String']['input'];
  customerLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetResolvedSkuUpcMappingsQuery = { __typename?: 'Query', resolveSkuUpcMappings: Array<{ __typename?: 'SkuUpcMappingResolution', itemId: string, mapping?: { __typename?: 'SkuUpcMapping', id: string, tenantId: string, customerItemId: string, itemId: string, customerId: string, customerName: string, locationId?: string | null, locationName: string, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveShippingUomSource: Types.ShippingUomSource, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailShelfPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null }> };

export type ResolveShippingUomMappingsQueryVariables = Types.Exact<{
  itemIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  customerId: Types.Scalars['String']['input'];
  customerLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ResolveShippingUomMappingsQuery = { __typename?: 'Query', resolveSkuUpcMappings: Array<{ __typename?: 'SkuUpcMappingResolution', itemId: string, mapping?: { __typename?: 'SkuUpcMapping', effectiveShippingUomId?: string | null, effectiveShippingUomSource: Types.ShippingUomSource, shippingConfigCategoryCode?: string | null } | null }> };

export type SkuUpcMappingShippingUomFragment = { __typename?: 'SkuUpcMapping', effectiveShippingUomId?: string | null, effectiveShippingUomSource: Types.ShippingUomSource, shippingConfigCategoryCode?: string | null };

export type SkuUpcMappingFragment = { __typename?: 'SkuUpcMapping', id: string, tenantId: string, customerItemId: string, itemId: string, customerId: string, customerName: string, locationId?: string | null, locationName: string, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveShippingUomSource: Types.ShippingUomSource, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailShelfPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type CustomerItemStateFragment = { __typename?: 'CustomerItemStateData', tenantId: string, customerItemId: string, itemId: string, customerId: string, locationId?: string | null, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type CustomerItemTypedErrorsFragment = { __typename?: 'CustomerItemTypedErrors', effectiveDateOverlap?: { __typename?: 'CustomerItemEffectiveDateOverlap', customerItemId: string, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null } | null, upcSkuCollision?: { __typename?: 'CustomerItemUpcSkuCollision', customerItemId: string, sku: string, upc: string } | null };

export const SkuUpcMappingShippingUomFragmentDoc = new TypedDocumentString(`
    fragment SkuUpcMappingShippingUom on SkuUpcMapping {
  effectiveShippingUomId
  effectiveShippingUomSource
  shippingConfigCategoryCode
}
    `, {"fragmentName":"SkuUpcMappingShippingUom"});
export const SkuUpcMappingFragmentDoc = new TypedDocumentString(`
    fragment SkuUpcMapping on SkuUpcMapping {
  id
  tenantId
  customerItemId
  itemId
  customerId
  customerName
  locationId
  locationName
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  effectiveShippingUomId
  effectiveShippingUomSource
  program
  isDefault
  status
  retailShelfPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"SkuUpcMapping"});
export const CustomerItemStateFragmentDoc = new TypedDocumentString(`
    fragment CustomerItemState on CustomerItemStateData {
  tenantId
  customerItemId
  itemId
  customerId
  locationId
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  shippingUomId
  program
  isDefault
  status
  retailPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"CustomerItemState"});
export const CustomerItemTypedErrorsFragmentDoc = new TypedDocumentString(`
    fragment CustomerItemTypedErrors on CustomerItemTypedErrors {
  effectiveDateOverlap {
    customerItemId
    effectiveFrom
    effectiveUntil
  }
  upcSkuCollision {
    customerItemId
    sku
    upc
  }
}
    `, {"fragmentName":"CustomerItemTypedErrors"});
export const GetSkuUpcMappingsDocument = new TypedDocumentString(`
    query GetSkuUpcMappings($itemId: String!, $where: SkuUpcMappingFilterInput, $order: [SkuUpcMappingSortInput!], $first: Int, $after: String) {
  skuUpcMappings(
    itemId: $itemId
    where: $where
    order: $order
    first: $first
    after: $after
  ) {
    nodes {
      ...SkuUpcMapping
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment SkuUpcMapping on SkuUpcMapping {
  id
  tenantId
  customerItemId
  itemId
  customerId
  customerName
  locationId
  locationName
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  effectiveShippingUomId
  effectiveShippingUomSource
  program
  isDefault
  status
  retailShelfPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetSkuUpcMappingsForItemsDocument = new TypedDocumentString(`
    query GetSkuUpcMappingsForItems($itemIds: [String!]!, $where: SkuUpcMappingFilterInput, $order: [SkuUpcMappingSortInput!], $first: Int, $after: String) {
  skuUpcMappingsForItems(
    itemIds: $itemIds
    where: $where
    order: $order
    first: $first
    after: $after
  ) {
    nodes {
      ...SkuUpcMapping
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment SkuUpcMapping on SkuUpcMapping {
  id
  tenantId
  customerItemId
  itemId
  customerId
  customerName
  locationId
  locationName
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  effectiveShippingUomId
  effectiveShippingUomSource
  program
  isDefault
  status
  retailShelfPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const ResolveSkuUpcMappingDocument = new TypedDocumentString(`
    query ResolveSkuUpcMapping($customerId: String!, $customerLocationId: String, $itemId: String!, $atMoment: DateTime) {
  resolveSkuUpcMapping(
    customerId: $customerId
    customerLocationId: $customerLocationId
    itemId: $itemId
    atMoment: $atMoment
  ) {
    ...SkuUpcMapping
  }
}
    fragment SkuUpcMapping on SkuUpcMapping {
  id
  tenantId
  customerItemId
  itemId
  customerId
  customerName
  locationId
  locationName
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  effectiveShippingUomId
  effectiveShippingUomSource
  program
  isDefault
  status
  retailShelfPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const GetResolvedSkuUpcMappingsDocument = new TypedDocumentString(`
    query GetResolvedSkuUpcMappings($itemIds: [String!]!, $customerId: String!, $customerLocationId: String) {
  resolveSkuUpcMappings(
    itemIds: $itemIds
    customerId: $customerId
    customerLocationId: $customerLocationId
  ) {
    itemId
    mapping {
      ...SkuUpcMapping
    }
  }
}
    fragment SkuUpcMapping on SkuUpcMapping {
  id
  tenantId
  customerItemId
  itemId
  customerId
  customerName
  locationId
  locationName
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  effectiveShippingUomId
  effectiveShippingUomSource
  program
  isDefault
  status
  retailShelfPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const ResolveShippingUomMappingsDocument = new TypedDocumentString(`
    query ResolveShippingUomMappings($itemIds: [String!]!, $customerId: String!, $customerLocationId: String) {
  resolveSkuUpcMappings(
    itemIds: $itemIds
    customerId: $customerId
    customerLocationId: $customerLocationId
  ) {
    itemId
    mapping {
      ...SkuUpcMappingShippingUom
    }
  }
}
    fragment SkuUpcMappingShippingUom on SkuUpcMapping {
  effectiveShippingUomId
  effectiveShippingUomSource
  shippingConfigCategoryCode
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetSkuUpcMappings: build.query<GetSkuUpcMappingsQuery, GetSkuUpcMappingsQueryVariables>({
      query: (variables) => ({ document: GetSkuUpcMappingsDocument, variables })
    }),
    GetSkuUpcMappingsForItems: build.query<GetSkuUpcMappingsForItemsQuery, GetSkuUpcMappingsForItemsQueryVariables>({
      query: (variables) => ({ document: GetSkuUpcMappingsForItemsDocument, variables })
    }),
    ResolveSkuUpcMapping: build.query<ResolveSkuUpcMappingQuery, ResolveSkuUpcMappingQueryVariables>({
      query: (variables) => ({ document: ResolveSkuUpcMappingDocument, variables })
    }),
    GetResolvedSkuUpcMappings: build.query<GetResolvedSkuUpcMappingsQuery, GetResolvedSkuUpcMappingsQueryVariables>({
      query: (variables) => ({ document: GetResolvedSkuUpcMappingsDocument, variables })
    }),
    ResolveShippingUomMappings: build.query<ResolveShippingUomMappingsQuery, ResolveShippingUomMappingsQueryVariables>({
      query: (variables) => ({ document: ResolveShippingUomMappingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetSkuUpcMappingsQuery, useLazyGetSkuUpcMappingsQuery, useGetSkuUpcMappingsForItemsQuery, useLazyGetSkuUpcMappingsForItemsQuery, useResolveSkuUpcMappingQuery, useLazyResolveSkuUpcMappingQuery, useGetResolvedSkuUpcMappingsQuery, useLazyGetResolvedSkuUpcMappingsQuery, useResolveShippingUomMappingsQuery, useLazyResolveShippingUomMappingsQuery } = injectedRtkApi;
